import { api } from 'src/services/api'

type Response = {
  value: number
  waiting_value: number
}

export async function getBalance() {
  try {
    const token = localStorage.getItem('@stricv2:token')
    const user = await JSON.parse(localStorage.getItem('@stricv2:user')!)

    if (user?.virtual_account_id) {
      const response = await api.get<Response>(
        `/graphic/balance/${user.virtual_account_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } else {
      const response = await api.get<Response>(`/graphic/balance`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    }
  } catch (error) {
    console.error(error)
  }
}
